module.exports = __webpack_public_path__ + "static/media/logo-light.65252fdd.PNG";